<template>
  <div class="footerBox">
    <div class="footerTopBox">
      <div class="footerTop">
        <div class="sm">微信扫码关注</div>
        <div>
          <van-swipe class="footer-swipe" :autoplay="3000">
            <van-swipe-item>
              <div class="footerS"></div>
              <div class="foTitle">携船网APP</div>
              <div class="foTitle">海运综合服务平台</div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="footerS2"></div>
              <div class="foTitle">携船网公众号</div>
              <div class="foTitle">快速体验平台服务</div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="footerS3"></div>
              <div class="foTitle">携船网资讯</div>
              <div class="foTitle">行业热点一手掌握</div>
            </van-swipe-item>
            <!--                        <van-swipe-item>-->
            <!--                            <div class="footerS"></div>-->
            <!--                            <div class="foTitle">承运通公众号</div>-->
            <!--                        </van-swipe-item>-->
            <!--                        <van-swipe-item>-->
            <!--                            <div class="footerS1"></div>-->
            <!--                            <div class="foTitle">好洼地小程序</div>-->
            <!--                        </van-swipe-item>-->


          </van-swipe>
        </div>
      </div>
    </div>
    <div class="footer">
      <div style="display: flex;flex-direction: column;align-items: center;">
        <div style="display: flex;align-items: center">
          <img style="height: 16px;width: 14px;" src="../../assets/icon-beian.png">
          <span onclick='window.open("https://beian.mps.gov.cn/#/query/webSearch?code=35012102500789")'>闽公网安备35012102500789</span>
        </div>
        <div
          onclick='window.open("http://beian.miit.gov.cn")' style="cursor:pointer">ICP证：闽ICP备17010162号
        </div>
        <div>©2016-2024 携船网（福建）航运科技有限公司版权所有</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      subFlag: true
    }
  },
  created() {

  },
  methods: {}
}
</script>
<style lang='less' rel='stylesheet/less'>
@rem: 16rem;
.footerBox {


  .footerTopBox {
    background: #272d38;
    width: 100%;
    height: 220/@rem;

    .foTitle {
      text-align: center;
      color: #fff;
      font-size: 11/@rem;
      //line-height: 20/@rem;
      color: #9599a3;
    }

    .footerTop {
      width: 100%;
      height: 220/@rem;
      background-image: url(../../assets/f-bg.png);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;

      .sm {
        font-size: 14/@rem;
        text-align: center;
        color: #fff;
        padding-top: 24/@rem;
        padding-bottom: 0.48rem;
        letter-spacing: 0.1rem;
        background-image: url(../../assets/coloum-line.png);
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: 1.48rem 0.18rem;
      }

      .footer-swipe {
        margin-top: 0.4rem;
        height: 160/@rem;

        .footerS {
          width: 104/@rem;
          height: 104/@rem;
          margin: 0.2rem auto;
          background-image: url(../../assets/f-1.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .footerS1 {
          width: 104/@rem;
          height: 104/@rem;
          margin: 0.2rem auto;
          background-image: url(../../assets/f-2.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .footerS2 {
          width: 104/@rem;
          height: 104/@rem;
          margin: 0.2rem auto;
          background-image: url(../../assets/f-3.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        .footerS3 {
          width: 104/@rem;
          height: 104/@rem;
          margin: 0.2rem auto;
          background-image: url(../../assets/f-4.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }

    }
  }

  .footer {

    width: 100%;
    background: #1D2129;

    div {
      padding: 2/@rem 0/@rem;
      text-align: center;
      color: #666666;
      font-size: 11/@rem;
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/nav/footer.vue